import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class KnownSourceApi {
  getKnownSources = async (params = {}) => {
    try {
      const response = await api.get("/known-source", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  saveKnownSource = async (data) => {
    try {
      const response = await api.post("/known-source", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to add source";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateKnownSource = async (id, data) => {
    try {
      const response = await api.put(`/known-source/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification("Source Updated Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to update source";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteKnownSource = async (id) => {
    try {
      const response = await api.delete(`/known-source/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to delete source";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const knownSourceApi = new KnownSourceApi();
export default knownSourceApi;

export const {
  getKnownSources,
  saveKnownSource,
  updateKnownSource,
  deleteKnownSource,
} = knownSourceApi;
